import React, { useState, useEffect } from 'react';
import axios from 'axios';


const API_URL = process.env.REACT_APP_API_URL;

const OccupationManagement = () => {
  const [occupations, setOccupations] = useState([]);
  const [newOccupation, setNewOccupation] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');


  useEffect(() => {
    fetchOccupations();
  }, []);

  const fetchOccupations = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/occupations`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOccupations(response.data);
      setError('');
    } catch (error) {
      console.error('Error fetching occupations:', error);
      setError('職業データの取得に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  const handleAddOccupation = async () => {
    if (!newOccupation.trim()) {
      setError('職業名を入力してください。');
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/api/occupations`, 
        { occupaionName: newOccupation },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setOccupations([...occupations, response.data]);
      setNewOccupation('');
      setSuccess('職業を追加しました。');
      setError('');
      
      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error adding occupation:', error);
      const errorMessage = error.response?.data?.message || '職業の追加に失敗しました。';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteOccupation = async (id) => {
    if (!window.confirm('この職業を削除しますか？')) {
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/api/occupations/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setOccupations(occupations.filter(occupation => occupation._id !== id));
      setSuccess('職業を削除しました。');
      setError('');
      
      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error deleting occupation:', error);
      const errorMessage = error.response?.data?.message || '職業の削除に失敗しました。';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddOccupation();
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ 
        color: '#2c3e50', 
        marginBottom: '30px',
        fontSize: '24px',
        borderBottom: '2px solid #3498db',
        paddingBottom: '10px'
      }}>
        職業管理
      </h2>

      {/* Success/Error Messages */}
      {success && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '1px solid #c3e6cb'
        }}>
          {success}
        </div>
      )}
      
      {error && (
        <div style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '1px solid #f5c6cb'
        }}>
          {error}
        </div>
      )}

      {/* Add New Occupation */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '18px'
        }}>
          新しい職業を追加
        </h3>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="text"
            value={newOccupation}
            onChange={(e) => setNewOccupation(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="例: 会社員、自営業、学生"
            style={{
              flex: 1,
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              fontSize: '14px'
            }}
          />
          <button
            onClick={handleAddOccupation}
            disabled={loading || !newOccupation.trim()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#27ae60',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: loading || !newOccupation.trim() ? 'not-allowed' : 'pointer',
              opacity: loading || !newOccupation.trim() ? 0.6 : 1,
              fontSize: '14px'
            }}
          >
            {loading ? '追加中...' : '追加'}
          </button>
        </div>
      </div>

      {/* Occupations List */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '18px',
          padding: '20px 20px 0 20px'
        }}>
          職業一覧
        </h3>
        
        {loading ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px',
            color: '#666'
          }}>
            読み込み中...
          </div>
        ) : occupations.length === 0 ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px',
            color: '#666'
          }}>
            職業が登録されていません。
          </div>
        ) : (
          <div style={{ padding: '0 20px 20px 20px' }}>
            {occupations.map((occupation, index) => (
              <div
                key={occupation._id}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '15px',
                  borderBottom: index < occupations.length - 1 ? '1px solid #eee' : 'none',
                  backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
                }}
              >
                <div style={{ flex: 1 }}>
                  <span style={{ 
                    fontSize: '16px',
                    color: '#2c3e50',
                    fontWeight: '500'
                  }}>
                    {occupation.occupaionName}
                  </span>
                  <div style={{ 
                    fontSize: '12px',
                    color: '#666',
                    marginTop: '5px'
                  }}>
                    ID: {occupation._id}
                  </div>
                </div>
                <button
                  onClick={() => handleDeleteOccupation(occupation._id)}
                  disabled={loading}
                  style={{
                    padding: '8px 15px',
                    backgroundColor: '#e74c3c',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.6 : 1,
                    fontSize: '12px'
                  }}
                >
                  削除
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Statistics */}
      <div style={{
        backgroundColor: '#e8f4fd',
        padding: '15px',
        borderRadius: '8px',
        marginTop: '20px',
        border: '1px solid #bee5eb'
      }}>
        <h4 style={{ 
          color: '#0c5460', 
          marginBottom: '10px',
          fontSize: '16px'
        }}>
          統計情報
        </h4>
        <div style={{ color: '#0c5460', fontSize: '14px' }}>
          登録済み職業: {occupations.length}件
        </div>
      </div>
    </div>
  );
};

export default OccupationManagement; 